var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('DocumentsFilters',{attrs:{"default":_vm.filters},on:{"applyFilters":_vm.applyFilters}}),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-block"},[_c('CoachsDocumentsToValidatedList',{attrs:{"coachs":_vm.coachs}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }